import { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Operational.css";

import man from "./assets/man.svg";
import man2 from "./assets/Man1.svg";
import man3 from "./assets/Man2.jpg";

const OperationalPlanning = () => {
  const tabs = [
    "Workload Planning",
    "Capacity Planning",
    "Equipment Maintenance",
  ];

  const cards = [
    {
      id: "workload",
      title: "Workload Planning",
      description:
        "Plan and schedule your Vessel, Crane, CHE’s and Labour efficiently via integration to TOS or predefined Equipment Requirement Matrices and Resource Sets, in order to define accurate time and location defined workload requirements.",
      image: man,
    },
    {
      id: "capacity",
      title: "Capacity Planning",
      description:
        "Have Equipment and Resource availability information on hand to immediately make strategic operational planning decisions like increasing the number of scheduled equipment and manipulating Equipment Manning Ratios.",
      image: man2,
    },
    {
      id: "maintenance",
      title: "Equipment Maintenance",
      description:
        "Automated, via integration to M&R systems, or manually updated JIVIEWS ensures that only available equipment can be selected for operations at any given time.",
      image: man3,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const cardsRef = useRef([]);

  const [vw, setVw] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = vw <= 768;

  const handleTabClick = (idx) => {
    setActiveIndex(idx);

    const cardElement = cardsRef.current[idx];
    if (!cardElement) return;

    const headerOffset = isMobile ? 180 : 160;
    const cardTop =
      cardElement.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: cardTop - headerOffset,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = cardsRef.current.indexOf(entry.target);
            if (idx !== -1) setActiveIndex(idx);
          }
        });
      },
      { threshold: 0.5 }
    );

    cardsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  return (
    <section className="op-section">
      
      <div className={`op-tabs ${isMobile ? "mobile" : ""}`}>
        {tabs.map((tab, idx) => (
          <button
            key={tab}
            onClick={() => handleTabClick(idx)}
            className={`op-tab ${activeIndex === idx ? "active" : ""}`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="op-cards">
        {cards.map((card, idx) => (
          <div
            key={card.id}
            ref={(el) => (cardsRef.current[idx] = el)}
            className={`op-card ${activeIndex === idx ? "active" : ""} ${
              isMobile ? "mobile" : ""
            }`}
          >
            <div className="op-card-text">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>

            <div className="op-card-image">
              <img src={card.image} alt={card.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OperationalPlanning;
